import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-info-tooltip-hover',
    templateUrl: 'info-tooltip-hover.component.html',
    styleUrls: ['info-tooltip-hover.component.scss'],
    standalone: false
})
export class InfoTooltipHoverComponent implements OnInit, AfterViewInit {

  @ViewChild('infoTooltipHover') infoTooltipHoverRef: ElementRef;

  @Input() host: HTMLElement;
  @Input() position: 'top'|'bottom'|'left'|'right'|'right-ltd'|'custom'|'dropdown'|'bottom-left'|'bottom-right'|'bottom-right-wp'|'top-right-wp'|'top-left-wp'|'top-right-tw-care'|'top-right'|'top-left'|'top-left-additional'|'google-score-desc'|'bottom-right-front'|'bottom-right-header'|'bottom-from-start'|'top-from-start'|'top-from-end'|'top-from-start-ltd'|'top-from-start-ltd-price'|'top-from-start-ltd-dialog'|'bottom-middle'|'pricing-tooltip'|'bottom-right-cp-website'|'top-custom'|'bottom-from-icon-start'|'left-custom';
  @Input() delay: number;
  @Input() infoTooltipHoverHeader: string;
  @Input() infoTooltipHoverBody: string;
  @Input() infoTooltipHoverMoreInfo: string;
  @Input() infoTooltipHoverEvent: string = 'click';
  @Input() premiumUpgrade: boolean;
  @Input() smallTooltip: boolean = false;
  @Input() shadow: boolean = true;
  @Input() withImage: boolean = false;
  @Input() dbInfoTooltipHoverCustomClass?: string;
  @Output() cancelHideEvent = new EventEmitter<any>();
  @Input() infoTooltipMoreInfoLink?: string;
  @Input() infoTooltipMoreInfoLinkText?: string;
  @Input() infoTooltipColor?: string;
  @Input() gapVertical?: number = 0;
  @Input() gapHorizontal?: number = 0;
  @Input() gapPositionVertical?: string;
  @Input() gapPositionHorizontal?: string;
  @Input() eventTitle?: string;

  public infoTooltipHoverStyle: any;
  public toggled: boolean;


  private top: any;
  private left: any;

  constructor(
    private $element: ElementRef,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.infoTooltipHoverStyle = {};
  }

  ngOnInit() {}
  ngAfterViewInit() {
    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const infoTooltipHoverBoundingBox: ClientRect = this.infoTooltipHoverRef.nativeElement.getBoundingClientRect();
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    switch (this.position) {
      case 'top':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - infoTooltipHoverBoundingBox.width / 2;
        break;

      case 'top-right':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 10;
        if (hostBoundingBox.right + 20 > window.innerWidth) {
          this.left = hostBoundingBox.right - 150;
        }
        else {
          this.left = hostBoundingBox.right - 150;
        }
        break;

      case 'top-left':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 10;
        this.left = hostBoundingBox.left + 130 - infoTooltipHoverBoundingBox.width;
        break;


      case 'top-left-additional':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 10;
        this.left = hostBoundingBox.right - 200;
        break;

      case 'bottom':
        this.top = hostBoundingBox.bottom;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - infoTooltipHoverBoundingBox.width / 2;
        break;

      case 'bottom-right':
        this.top = hostBoundingBox.bottom - 10;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width - 17;
        }
        else {
          this.left = hostBoundingBox.right - hostBoundingBox.width - 17;
        }
        break;

      case 'bottom-right-wp':
        this.top = hostBoundingBox.bottom;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right - 42;
        }
        break;

      case 'bottom-right-front':
        this.top = hostBoundingBox.bottom ;
        if (hostBoundingBox.right + 134 > window.innerWidth) {
          this.left = hostBoundingBox.right - 134 - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right - 42;
        }
        break;

      case 'bottom-right-header':
        this.top = hostBoundingBox.bottom - 10;
        this.left = hostBoundingBox.right - 16 - hostBoundingBox.width;
        break;

      case 'top-right-wp':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 5;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width + 14;
        }
        else {
          this.left = hostBoundingBox.right - 42;
        }
        break;

      case 'top-right-tw-care':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 40;
        if (hostBoundingBox.right + 250 > window.innerWidth) {
          this.left = hostBoundingBox.right - 250 - hostBoundingBox.width + 70;
        }
        else {
          this.left = hostBoundingBox.right - 2;
        }
        if (windowWidth < 991) {
          this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height;
          this.left = hostBoundingBox.left;
        }
        break;


      case 'top-left-wp':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 20;
        this.left = hostBoundingBox.left + 40 - infoTooltipHoverBoundingBox.width;
        break;

      case 'left':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - infoTooltipHoverBoundingBox.height / 2;
        this.left = hostBoundingBox.left - infoTooltipHoverBoundingBox.width;
        break;

      case 'bottom-left':
        this.top = hostBoundingBox.bottom - 10;
        this.left = hostBoundingBox.left + 40 - infoTooltipHoverBoundingBox.width;
        break;

      case 'right':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - infoTooltipHoverBoundingBox.height / 2;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right;
        }
        break;

      case 'right-ltd':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - infoTooltipHoverBoundingBox.height / 2;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right - 12;
        }
        break;

      case 'custom':
        this.top = hostBoundingBox.top;
        this.left = hostBoundingBox.left;
        break;

      case 'dropdown':
        this.top = hostBoundingBox.bottom - 9;
        this.left = hostBoundingBox.left + hostBoundingBox.width  - infoTooltipHoverBoundingBox.width;
        break;

      case 'google-score-desc':
        this.top = hostBoundingBox.bottom - 14;
        this.left = hostBoundingBox.left - 17;
        break;

      case 'bottom-from-start':
        this.top = hostBoundingBox.bottom + 29;
        this.left = hostBoundingBox.left + 20;
        break;

      case 'bottom-from-icon-start':

        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + hostBoundingBox.height;
        this.left = hostBoundingBox.left + 25;
        if (window.innerWidth < 576) {
          this.left = 24;
        }
        break;

      case 'top-from-start-ltd':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height;
        this.left = hostBoundingBox.left + 1;
        break;

      case 'top-from-start-ltd-price':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 11;
        this.left = hostBoundingBox.left + 1 - infoTooltipHoverBoundingBox.width / 2;
        break;

      case 'top-from-start':
        this.top = hostBoundingBox.top - 65;
        this.left = hostBoundingBox.left + 21;
        break;

      case 'top-from-end':
        this.top = hostBoundingBox.top - 65;
        this.left = hostBoundingBox.left + hostBoundingBox.width - infoTooltipHoverBoundingBox.width - 1;
        break;

      case 'top-from-start-ltd-dialog':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height + 15;
        this.left = hostBoundingBox.left - 20;
        break;

      case 'bottom-middle':
        this.top = hostBoundingBox.bottom;
        this.left = hostBoundingBox.left - infoTooltipHoverBoundingBox.width / 2 - 15;
        // this.left = hostBoundingBox.left / 2 + infoTooltipHoverBoundingBox.width / 2 - 60;
        break;

      case 'pricing-tooltip':
        let top;
        let left;
        /*Padding can be input from component*/
        const padding = 15;
        /*Depending on gap vertical position count top*/
        if (this.gapPositionVertical === 'top') {
          /*top of tooltip item        height of tooltip                gap from section    tooltip padding*/
          top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height - this.gapVertical + padding;
        }
        else {
          top = hostBoundingBox.top - padding + hostBoundingBox.height + this.gapVertical;
        }
        if (this.gapPositionHorizontal === 'left') {
          left = hostBoundingBox.left - this.gapHorizontal - padding;
        }
        else {
          left = hostBoundingBox.left + this.gapHorizontal - padding;
        }
        this.top = top;
        this.left = left;
        break;

      case 'bottom-right-cp-website':
        this.top = hostBoundingBox.bottom - 70;
        this.left = hostBoundingBox.right;
        break;

      case 'top-custom':
        this.top = hostBoundingBox.top - infoTooltipHoverBoundingBox.height - 3;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - infoTooltipHoverBoundingBox.width / 2 + 2;
        break;
      case 'left-custom':
        this.top = hostBoundingBox.top - (window.innerWidth < 991 ? infoTooltipHoverBoundingBox.height : infoTooltipHoverBoundingBox.height/2) + (window.innerWidth < 991 ? 8 : 19) ;
        this.left = hostBoundingBox.left + hostBoundingBox.width - 2;
        break;
    }

    setTimeout((): void => {
      this.infoTooltipHoverStyle = {
        top: this.top + 'px',
        left: this.left + 'px'
      };
    }, this.delay || 0);
  }

  public onMouseEnter(): void {
    this.host.classList.add("hovered");
    this.cancelHideEvent.emit('show');
  }

  public onMouseLeave(): void {
    this.host.classList.remove("hovered");;
    this.cancelHideEvent.emit('hide');
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
      if (!this.toggled && this.host.contains($event.target)) {
        this.toggled = true;
        $event.stopImmediatePropagation();
      }
      else {
        this.toggled = false;
        this.cancelHideEvent.emit('hide');
      }
  }

}
